// This function allow to reference async chunks
__webpack_require__.miniCssF = (chunkId) => {
	// return url for filenames based on template
	return "static/css/" + chunkId + "." + {"399":"555eae26","404":"0891c86d","596":"351f575d","770":"39765ea3"}[chunkId] + ".chunk.css";
};